import test from "@/utils/test";
export default function (res) {
  const { uuid: uid, name, phone: mobile, avatar, company, auth } = res ||{};
  const data = JSON.stringify([
    {
      key: "auth",
      label: "个人实名",
      value: auth ? "已实名" : "未实名"
    },
    {
      key: "companyAuth",
      label: "公司实名",
      value: company ? "已实名" : "未实名",
    },
    {
      "key": "avatar",
      "label": "头像",
      "value": avatar
    },
    {
      key: "company.name",
      label: "公司名",
      value: company?.name,
      hidden: test.empty(company?.name),
    },
    {
      key: "company.IdNumber",
      label: "公司证件号",
      value: company?.idNumber,
      hidden: test.empty(company?.idNumber),
    },
    {
      key: "company.representativeName",
      label: "法人代表姓名",
      value: company?.representativeName,
      hidden: test.empty(company?.representativeName),
    },
    {
      key: "company.representativeIdNumber",
      label: "法人代表证件号",
      value: company?.representativeIdNumber,
      hidden: test.empty(company?.representativeIdNumber),
    },
    {
      key: "company.representativePhone",
      label: "法人代表手机号",
      value: company?.representativePhone,
      hidden: test.empty(company?.representativePhone),
    },
  ]);
  return { uid, name, mobile, data };
}